module.exports = __webpack_public_path__ + "media/images/logo2-eeb2a707.png";